module.exports = __webpack_public_path__ + "img/9788957075975.fd5c787d.jpg";